import React from 'react';

const SettingsModal = ({
  isOpen,
  onClose,
  isAutoSaveEnabled,
  setIsAutoSaveEnabled,
  isSpellCheckEnabled,
  onToggleSpellCheck,
  editorTheme,
  onApplyTheme,
  fontSize,
  setFontSize,
  lineHeight,
  setLineHeight
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Editor Settings</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ×
          </button>
        </div>
        <div className="space-y-4">
          <div>
            <label className="flex items-center justify-between">
              <span className="text-sm font-medium">Auto-save</span>
              <input
                type="checkbox"
                checked={isAutoSaveEnabled}
                onChange={(e) => setIsAutoSaveEnabled(e.target.checked)}
                className="rounded"
              />
            </label>
          </div>
          <div>
            <label className="flex items-center justify-between">
              <span className="text-sm font-medium">Spell Check</span>
              <input
                type="checkbox"
                checked={isSpellCheckEnabled}
                onChange={onToggleSpellCheck}
                className="rounded"
              />
            </label>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Theme</label>
            <select
              value={editorTheme}
              onChange={(e) => onApplyTheme(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="light">Light</option>
              <option value="dark">Dark</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              Font Size
            </label>
            <input
              type="range"
              min="12"
              max="24"
              value={fontSize}
              onChange={(e) => setFontSize(parseInt(e.target.value))}
              className="w-full"
            />
            <div className="text-xs text-gray-500 text-center">
              {fontSize}px
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              Line Height
            </label>
            <input
              type="range"
              min="1.2"
              max="2.0"
              step="0.1"
              value={lineHeight}
              onChange={(e) => setLineHeight(parseFloat(e.target.value))}
              className="w-full"
            />
            <div className="text-xs text-gray-500 text-center">
              {lineHeight}
            </div>
          </div>
        </div>
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsModal;